import { Heading, Icon } from '@assembly-js/design-system';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/system';
import clsx from 'clsx';
import React from 'react';

interface PageTitleMenuButtonProps {
  title: string;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  className?: string;
  truncateTitle?: boolean;
}

export const PageTitleMenuButton = React.forwardRef<
  HTMLButtonElement,
  PageTitleMenuButtonProps
>(({ title, onClick, className, truncateTitle = true }, ref) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <button
      ref={ref}
      type="button"
      onClick={onClick}
      className={clsx(
        // The negative margin is used to align the title text with the page
        // content elements. The title color is explicit because iOS Safari
        // paints unstyled button text with the system accent blue.
        'flex items-center gap-2 p-1 px-2 rounded bg-transparent border-0 cursor-pointer hover:bg-primary-hover -ml-2 min-w-0 overflow-hidden text-black-heading',
        isMobile && truncateTitle && 'max-w-full',
        className,
      )}
    >
      <span className={clsx(truncateTitle && 'min-w-0')}>
        <Heading size="sm" className={clsx(truncateTitle && 'truncate')}>
          {title}
        </Heading>
      </span>
      <Icon icon="ChevronDown" className="w-3 h-3 shrink-0 text-secondary" />
    </button>
  );
});
PageTitleMenuButton.displayName = 'PageTitleMenuButton';
